<script>
import appConfig from "@/app.config";
import Km from "../../../components/document/contracts/km.vue"
import Cn from "../../../components/document/contracts/cn.vue"
import En from "../../../components/document/contracts/en.vue"
import { contractService } from "../../../services/saleservice/contract.service";
/* eslint-disable no-console */
/**
 * Invoice-detail component
 */

export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Km,
    Cn,
    En
  },
  data() {
    return {
      title: "Invoice Detail",
      items: [
        {
          text: "Invoices",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],

      contract: null,
      template: 3,
      
    };
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    }
    
  },
  methods: {
    
     
    loadingData: function(id) {

      this.fetchingStats = false;
      contractService.getContract(id)
        .then(response => {
          this.fetchingStats = true;
          this.contract = response.data;
          this.template = this.contract.template_id;

          console.log("Sale", this.contract);
        });
        
    },
    loadingPropertyById: function(id) {
      this.fetchingStats = false;
      contractService.getContractByProperty(id)
        .then(response => {
          this.fetchingStats = true;
          this.contract = response.data;
          this.template = this.contract.template_id;

          console.log("Property", this.contract);
        });
    },

  },
};
</script>

<template>

  
  <Cn v-if="template == 6" :data="contract" />
  <En v-else-if="template == 5" :data="contract" />
  <Km v-else :data="contract" />

  <!-- <Cn :data="this.contract" /> -->
</template>